import { formatMoney } from 'libs/shopify'

const PriceTag = ({ priceWrapperClass, isSale, classSize, originalPrice, colorSalePrice, price }) => {
  return (
    <div className={priceWrapperClass}>
      {isSale ? <span className={`line-through ${classSize}`}>{formatMoney(originalPrice)}</span> : ''}
      <span className={colorSalePrice}>{formatMoney(price)}</span>
    </div>
  )
}

const SaleTag = ({ showTextSale, textSale }) => {
  return (
    showTextSale && textSale > 0 && (
        <span className="flex h-5 items-center justify-center rounded-full bg-success-bg px-2.5 text-xxs font-medium uppercase text-success-content lg:h-[22px] js-price-label-sale">{`Save $${textSale}`}</span>
    )
  )
}

function Price({
  className = '',
  price = 0,
  originalPrice = null,
  classSize = 'text-sm',
  classColor = '!text-grey-900',
  priceWrapperClass = 'flex flex-row gap-2',
  showTextSale = false
}) {
  const customClass = `price ${className}`
  const isSale = originalPrice && originalPrice !== 0 && originalPrice > price
  const colorSalePrice = isSale ? `${classSize} ${classColor}` : `${classSize}`
  const textSale = Math.round(originalPrice - price) / 100

  return (
    <div className={customClass}>
      <PriceTag
        priceWrapperClass={priceWrapperClass}
        isSale={isSale}
        classSize={classSize}
        originalPrice={originalPrice}
        colorSalePrice={colorSalePrice}
        price={price}
      />
      <SaleTag showTextSale={ showTextSale } textSale={ textSale } />
    </div>
  )
}

export default Price
